import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../services/api';
import { openExternalWithNotice } from '../utils/externalLinks';
import { phoneHref } from '../utils/phone';
import './Facilities.css';
import { directionsUrl, GoogleLocationMap } from '../components/maps/LocationMap';
import LoadingSpinner from '../components/common/LoadingSpinner';

const Icon = ({ name }) => {
  const paths = {
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    grid: <><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></>,
    list: <><path d="M8 6h13M8 12h13M8 18h13" /><path d="M3 6h.01M3 12h.01M3 18h.01" /></>,
    phone: <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.2 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.6a2 2 0 0 1-.45 2.11L8 9.68a16 16 0 0 0 6.32 6.32l1.25-1.25a2 2 0 0 1 2.11-.45c.83.27 1.7.47 2.6.59A2 2 0 0 1 22 16.92Z" />,
    mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
    map: <><path d="M12 21s7-4.7 7-11a7 7 0 1 0-14 0c0 6.3 7 11 7 11Z" /><circle cx="12" cy="10" r="2.5" /></>,
    clock: <><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></>,
    user: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
    badge: <><path d="M12 3 4 6v6c0 5 3.4 8.2 8 9 4.6-.8 8-4 8-9V6l-8-3Z" /><path d="m9 12 2 2 4-4" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    arrow: <path d="M5 12h14M13 5l7 7-7 7" />,
    building: <><path d="M4 21V7l8-4 8 4v14" /><path d="M9 21v-6h6v6" /><path d="M8 9h.01M12 9h.01M16 9h.01" /></>,
    health: <><path d="M12 21s-7-4.35-7-10a4 4 0 0 1 7-2.65A4 4 0 0 1 19 11c0 5.65-7 10-7 10Z" /><path d="M12 8v6M9 11h6" /></>,
    water: <path d="M12 22a7 7 0 0 0 7-7c0-5-7-13-7-13S5 10 5 15a7 7 0 0 0 7 7Z" />,
    bolt: <path d="M13 2 4 14h7l-1 8 10-13h-7l0-7Z" />,
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />,
    book: <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5Z" /></>,
    fire: <path d="M12 22c4 0 7-2.7 7-6.4 0-2.6-1.6-4.5-3.6-6.3-.8 2.6-2.4 3.5-2.4 3.5.3-3-1.2-6-4-8.8.2 3.5-2.4 5.2-3.4 7.8C4.5 14.5 5 22 12 22Z" />,
    service: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .35 1.88l.05.05a2 2 0 1 1-2.83 2.83l-.05-.05A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1.1V21a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 8 19.4a1.7 1.7 0 0 0-1.88.35l-.05.05a2 2 0 1 1-2.83-2.83l.05-.05A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1.1-.4H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.6 8a1.7 1.7 0 0 0-.35-1.88l-.05-.05a2 2 0 1 1 2.83-2.83l.05.05A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1.1V3a2 2 0 1 1 4 0v.1A1.7 1.7 0 0 0 15 4.6a1.7 1.7 0 0 0 1.88-.35l.05-.05a2 2 0 1 1 2.83 2.83l-.05.05A1.7 1.7 0 0 0 19.4 9c.2.37.4.67.6 1 .3.3.7.4 1.1.4h.1a2 2 0 1 1 0 4h-.1c-.4 0-.8.1-1.1.4-.3.2-.5.5-.6.9Z" /></>,
  };
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.building}</svg>;
};

const facilityTypes = [
  { value: 'all', label: 'सर्व सुविधा', icon: 'grid' },
  { value: 'hospital', label: 'रुग्णालय', icon: 'health' },
  { value: 'health_center', label: 'आरोग्य केंद्र', icon: 'health' },
  { value: 'ambulance', label: 'रुग्णवाहिका', icon: 'health' },
  { value: 'emergency_service', label: 'आपत्कालीन सेवा', icon: 'shield' },
  { value: 'tourism', label: 'पर्यटन', icon: 'map' },
  { value: 'religious_site', label: 'धार्मिक स्थळ', icon: 'building' },
  { value: 'educational', label: 'शैक्षणिक सुविधा', icon: 'book' },
  { value: 'water_supply', label: 'पाणीपुरवठा', icon: 'water' },
  { value: 'electricity', label: 'वीज सुविधा', icon: 'bolt' },
  { value: 'fire_station', label: 'अग्निशमन', icon: 'fire' },
  { value: 'police', label: 'पोलीस मदत', icon: 'shield' },
  { value: 'veterinary', label: 'पशुवैद्यकीय', icon: 'health' },
  { value: 'other', label: 'इतर', icon: 'service' },
];

const typeMeta = (type) => facilityTypes.find(item => item.value === type) || facilityTypes[facilityTypes.length - 1];
const trimText = (value, limit = 96) => {
  const text = String(value || '').trim();
  return text.length > limit ? `${text.slice(0, limit)}...` : text;
};

const parseDetails = (value) => {
  if (!value) return [];
  let parsed = value;
  if (typeof value === 'string') {
    try {
      parsed = JSON.parse(value);
    } catch {
      return [{ label: 'अतिरिक्त माहिती', value }];
    }
  }
  if (Array.isArray(parsed)) {
    return parsed.map((item, index) => ({
      label: item?.label || item?.title || `माहिती ${index + 1}`,
      value: item?.value || item?.description || item,
    }));
  }
  if (typeof parsed === 'object') {
    return Object.entries(parsed).map(([label, detail]) => ({ label, value: detail }));
  }
  return [{ label: 'अतिरिक्त माहिती', value: parsed }];
};

export default function Facilities() {
  const { tenantSlug } = useParams();
  const [facilities, setFacilities] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [search, setSearch] = useState('');
  const [view, setView] = useState('grid');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await api.get(`/tenant/${tenantSlug}/facilities`);
        setFacilities(response.data || []);
      } catch (err) {
        console.error('Error fetching facilities:', err);
        setError('सुविधा माहिती लोड करण्यात अडचण आली.');
      } finally {
        setLoading(false);
      }
    };

    if (tenantSlug) fetchFacilities();
  }, [tenantSlug]);

  const counts = useMemo(() => {
    const result = { all: facilities.length };
    facilities.forEach(facility => {
      result[facility.facility_type] = (result[facility.facility_type] || 0) + 1;
    });
    return result;
  }, [facilities]);

  const filteredFacilities = useMemo(() => {
    const query = search.trim().toLowerCase();
    return facilities.filter(facility => {
      const matchesType = selectedType === 'all' || facility.facility_type === selectedType;
      const searchable = [
        facility.name,
        typeMeta(facility.facility_type).label,
        facility.description,
        facility.address,
        facility.phone,
        facility.email,
        facility.in_charge_name,
      ].filter(Boolean).join(' ').toLowerCase();
      return matchesType && (!query || searchable.includes(query));
    });
  }, [facilities, search, selectedType]);

  const selectedMeta = selectedFacility ? typeMeta(selectedFacility.facility_type) : null;
  const selectedDetails = selectedFacility ? parseDetails(selectedFacility.additional_details) : [];
  const selectedMapUrl = directionsUrl(selectedFacility?.latitude, selectedFacility?.longitude, selectedFacility?.address);

  return (
    <div className="fac-page">
      <nav className="fac-breadcrumb">
        <Link to={`/gp/${tenantSlug}`}>मुख्यपृष्ठ</Link>
        <span>›</span>
        <span>सुविधा</span>
      </nav>

      <header className="fac-hero">
        <div>
          <span>ग्रामपंचायत सुविधा</span>
          <h1>सुविधा निर्देशिका</h1>
          <p>ग्रामपंचायत कार्यक्षेत्रातील सार्वजनिक सुविधा, संपर्क माहिती, वेळ आणि उपलब्धता एका ठिकाणी.</p>
        </div>
      </header>

      <div className="fac-layout">
        <aside className="fac-sidebar">
          <h2>सुविधा प्रकार</h2>
          <div className="fac-filter-list">
            {facilityTypes.filter(type => type.value === 'all' || counts[type.value]).map(type => (
              <button
                key={type.value}
                type="button"
                className={selectedType === type.value ? 'active' : ''}
                onClick={() => setSelectedType(type.value)}
              >
                <Icon name={type.icon} />
                <span>{type.label}</span>
                <b>{counts[type.value] || 0}</b>
              </button>
            ))}
          </div>
        </aside>

        <main className="fac-content-card">
          <div className="fac-toolbar">
            <div>
              <span>सर्व सुविधा</span>
              <h2>सुविधांची यादी</h2>
            </div>
            <label className="fac-search">
              <Icon name="search" />
              <input
                value={search}
                onChange={event => setSearch(event.target.value)}
                placeholder="सुविधा, पत्ता किंवा संपर्क शोधा..."
              />
            </label>
            <div className="fac-view-toggle" aria-label="दृश्य बदला">
              <button type="button" className={view === 'grid' ? 'active' : ''} onClick={() => setView('grid')}><Icon name="grid" /> ग्रिड दृश्य</button>
              <button type="button" className={view === 'list' ? 'active' : ''} onClick={() => setView('list')}><Icon name="list" /> लिस्ट दृश्य</button>
            </div>
          </div>

          {loading && <LoadingSpinner fullPage message="सुविधा लोड होत आहेत..." />}
          {!loading && error && <div className="fac-state error">{error}</div>}
          {!loading && !error && filteredFacilities.length === 0 && <div className="fac-state">या निकषांनुसार सुविधा सापडल्या नाहीत.</div>}

          {!loading && !error && filteredFacilities.length > 0 && (
            <div className={`fac-grid ${view === 'list' ? 'list' : ''}`}>
              {filteredFacilities.map((facility, index) => {
                const meta = typeMeta(facility.facility_type);
                return (
                  <article
                    key={facility.id}
                    className={`fac-card ${selectedFacility?.id === facility.id ? 'selected' : ''}`}
                  >
                    <div className="fac-card-head">
                      <span className="fac-number">{index + 1}</span>
                      <span className="fac-icon"><Icon name={meta.icon} /></span>
                      <div>
                        <h3>{facility.name}</h3>
                        <p>{meta.label}</p>
                      </div>
                    </div>

                    {facility.description && <p className="fac-card-desc">{trimText(facility.description)}</p>}

                    <dl className="fac-card-info">
                      {facility.in_charge_name && <div><Icon name="user" /><span>{facility.in_charge_name}</span></div>}
                      {facility.phone && <div><Icon name="phone" /><a href={phoneHref(facility.phone)}>{facility.phone}</a></div>}
                      {facility.opening_hours && <div><Icon name="clock" /><span>{facility.opening_hours}</span></div>}
                      {facility.availability && <div><Icon name="badge" /><span>{facility.availability}</span></div>}
                    </dl>

                    <div className="fac-card-actions">
                      <button type="button" onClick={() => setSelectedFacility(facility)}>
                        संपूर्ण माहिती
                      </button>
                      {facility.phone && <a href={phoneHref(facility.phone)}><Icon name="phone" /> संपर्क करा</a>}
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </main>
      </div>

      {selectedFacility && (
        <div className="fac-drawer-backdrop" onClick={() => setSelectedFacility(null)}>
          <aside className="fac-drawer" onClick={event => event.stopPropagation()}>
            <div className="fac-drawer-top">
              <button type="button" onClick={() => setSelectedFacility(null)}><Icon name="arrow" /> मागे जा</button>
              <button type="button" aria-label="बंद करा" onClick={() => setSelectedFacility(null)}><Icon name="close" /></button>
            </div>

            <header className="fac-drawer-hero">
              {selectedFacility.image_url ? (
                <img src={selectedFacility.image_url} alt={selectedFacility.name} />
              ) : (
                <span className="fac-drawer-icon"><Icon name={selectedMeta.icon} /></span>
              )}
              <div>
                <span>{selectedMeta.label}</span>
                <h2>{selectedFacility.name}</h2>
                <p>{selectedFacility.description || 'ग्रामपंचायत कार्यक्षेत्रातील महत्त्वाची सार्वजनिक सुविधा.'}</p>
                <div className="fac-status-row">
                  {selectedFacility.is_active !== false && <span className="active">सक्रिय</span>}
                  {selectedFacility.availability && <span>{selectedFacility.availability}</span>}
                </div>
              </div>
            </header>

            <div className="fac-drawer-body">
              <section>
                <h3>मूलभूत माहिती</h3>
                <dl>
                  <div><dt>सुविधा नाव</dt><dd>{selectedFacility.name}</dd></div>
                  <div><dt>सुविधा प्रकार</dt><dd>{selectedMeta.label}</dd></div>
                  {selectedFacility.availability && <div><dt>उपलब्धता</dt><dd>{selectedFacility.availability}</dd></div>}
                  {selectedFacility.opening_hours && <div><dt>कार्यालयीन वेळ</dt><dd>{selectedFacility.opening_hours}</dd></div>}
                </dl>
              </section>

              <section>
                <h3>संपर्क माहिती</h3>
                <dl>
                  {selectedFacility.in_charge_name && <div><dt>प्रभारी</dt><dd>{selectedFacility.in_charge_name}</dd></div>}
                  {selectedFacility.in_charge_phone && <div><dt>प्रभारी फोन</dt><dd><a href={phoneHref(selectedFacility.in_charge_phone)}><Icon name="phone" /> {selectedFacility.in_charge_phone}</a></dd></div>}
                  {selectedFacility.phone && <div><dt>फोन नंबर</dt><dd><a href={phoneHref(selectedFacility.phone)}><Icon name="phone" /> {selectedFacility.phone}</a></dd></div>}
                  {selectedFacility.email && <div><dt>ईमेल</dt><dd><a href={`mailto:${selectedFacility.email}`}><Icon name="mail" /> {selectedFacility.email}</a></dd></div>}
                  {selectedFacility.address && <div><dt>पत्ता</dt><dd><Icon name="map" /> {selectedFacility.address}</dd></div>}
                </dl>
              </section>

              {selectedDetails.length > 0 && (
                <section>
                  <h3>अतिरिक्त तपशील</h3>
                  <dl>
                    {selectedDetails.map((detail, index) => (
                      <div key={`${detail.label}-${index}`}>
                        <dt>{detail.label}</dt>
                        <dd>{String(detail.value || '—')}</dd>
                      </div>
                    ))}
                  </dl>
                </section>
              )}
              <GoogleLocationMap latitude={selectedFacility.latitude} longitude={selectedFacility.longitude} title={selectedFacility.name} address={selectedFacility.address} />
            </div>

            <footer className="fac-drawer-actions">
              {selectedFacility.phone && <a href={phoneHref(selectedFacility.phone)}><Icon name="phone" /> संपर्क करा</a>}
              {selectedMapUrl && <a href={selectedMapUrl} target="_blank" rel="noreferrer" onClick={event => openExternalWithNotice(event, selectedMapUrl)}><Icon name="map" /> दिशा मिळवा</a>}
            </footer>
          </aside>
        </div>
      )}
    </div>
  );
}
